import { render, staticRenderFns } from "./PeoplesPage.vue?vue&type=template&id=715b88e1"
import script from "./PeoplesPage.vue?vue&type=script&lang=js"
export * from "./PeoplesPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports